<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/school-desktop-banners/arni-school-of-technology-desktop.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/arni-school-of-technology-medium.webp">
        <img
            src="assets/img/school-mobile-banner/arni-school-of-technology-mobile.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>
<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div
            class="md:flex flex-wrap hidden space-x-4 p-6 mb-4 border-2 border-gray-200 rounded-full gap-y-3 mx-auto xl:justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 active-tab">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Courses</a>
            <a href="#specialization"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Specialization</a>
            <a href="#dean-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Dean's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">What's
                Happening</a>
            <a href="#expert-faculty"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Expert
                Faculty</a>
            <!--<a href="#testimonials"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Recruiters</a>
        </div>
        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">ARNI School of Technologies (AST) — Empowering Innovators, Shaping the
                Future</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-500 text-justify">
                The Arni School of Technology provides a comprehensive learning environment for students seeking careers
                in various technological fields. We offer a diverse range of courses, from undergraduate to postgraduate
                and doctoral levels, equipping you with the knowledge and skills to thrive in the ever-evolving world of
                technology. Our programs are designed in collaboration with industry experts, ensuring you acquire the
                most relevant skills and knowledge sought after by employers. We have highly qualified and experienced
                professors who are passionate about their fields and dedicated to your success. The Arni School of
                Technology provides cutting-edge laboratories and resources to gain practical experience and enhance
                your learning. We cultivate a supportive and collaborative learning environment that encourages your
                intellectual growth and personal development. We encourage extracurricular activities and foster a
                supportive learning environment to help you flourish as an individual.
            </p>
            <p class="text-gray-500 text-justify my-2">
                <strong>Vision</strong> – We have a long-term vision to craft a transformative learning environment
                where students are not just taught technical skills but are also provided with relevant exposure that
                helps them to lead and drive growth in the technological landscape.
            </p>
            <p class="text-gray-500 text-justify my-2">
                <strong>Mission</strong> – We are on a mission to spread knowledge and skills that empower students in
                this dynamic field of technology and innovation. We aim to provide them with a platform that encourages
                interdisciplinary collaboration, hands-on learning, and research-driven exploration.
            </p>
        </div>

        <div id="courses" class="section px-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-gray-500 text-justify">
                At AST, our programs are designed in collaboration with industry experts, ensuring that students gain a
                perfect blend of theoretical understanding and real-world applications. With state-of-the-art
                laboratories, research centers, and a future-oriented approach, Arni University ensures a holistic and
                industry-ready education.
                ARNI School of Technology offers postgraduate and undergraduate science courses designed in
                collaboration with industry experts. The program provides practical experience through cutting-edge
                laboratories and resources. The school fosters a supportive environment for intellectual growth and
                personal development, encouraging extracurricular activities and fostering a supportive learning
                environment for students to flourish as individuals.
            </p>
            <!-- <ul class="list-disc">
                 <li class="text-gray-500 text-justify my-2">
                     Undergraduate Programs
                     <ul>
                         <li>B.Tech (Various Specializations)</li>
                         <li>B.Sc (Science & Technology Disciplines)</li>
                     </ul>
                 </li>
                 <li class="text-gray-500 text-justify my-2">
                     Postgraduate Programs
                     <ul>
                         <li> M.Tech (Advanced Engineering Specializations)</li>
                         <li>M.Sc (Science and Applied Fields)</li>
                         <li>Diploma Programs</li>
                     </ul>
                 </li>
                 <li class="text-gray-500 text-justify my-2">
                     PhD Programs
                     <ul>
                         <li> Doctoral research opportunities across multiple technology and science domains with
                             guidance from
                             experienced faculty and access to state-of-the-art research facilities.
                         </li>
                     </ul>
                 </li>
                 <li class="text-gray-500 text-justify my-2">
                     Postgraduate Programs
                     <ul>
                         <li> M.Tech (Advanced Engineering Specializations)</li>
                         <li>M.Sc (Science and Applied Fields)</li>
                         <li>Diploma Programs</li>
                     </ul>
                 </li>
                 <li class="text-gray-500 text-justify my-2">
                     Certificate Courses
                     <ul>
                         <li> Short-duration, focused programs for upskilling in specialized areas like AI, Data Science,
                             IoT, Cloud
                             Computing, Cybersecurity, and more.
                         </li>
                     </ul>
                 </li>
             </ul>-->
            <p class="text-gray-500 text-justify mt-4">
                <strong>Scope:</strong>
                Arni School of Technology provides students with an unparalleled educational experience that blends
                theoretical knowledge with practical application. Through a combination of rigorous coursework, hands-on
                labs, and research opportunities, we empower our graduates to become:
            </p>
            <ul class="list-disc px-5">
                <li class="text-gray-500 text-justify my-2">Skilled technologists with the ability to solve complex
                    problems.
                </li>
                <li class="text-gray-500 text-justify my-2">Innovative thinkers who can drive technological
                    advancements.
                </li>
                <li class="text-gray-500 text-justify my-2">Industry-ready professionals prepared to make significant
                    contributions to their chosen fields.
                </li>
            </ul>
            <p class="text-gray-500 text-justify my-4 font-semibold">Here’s a possible scope for technology students
                after completing their Course.</p>
            <ul class="list-none space-y-2 text-justify mb-2 text-gray-500">
                <li class="flex items-start ">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Software development:</span>
                        Design, develop, and test software applications for a variety of purposes and platforms.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Computer engineering:</span>
                        Design, develop, and test computer hardware and software systems.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Mechanical engineering:</span>
                        Design, develop, build, and test mechanical systems and components.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Civil engineering:</span>
                        Plan, design, construct, and maintain infrastructure projects such as bridges, buildings, and
                        roads.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Research and development:</span>
                        Conduct research to develop new technologies and improve existing ones.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Data analysis:</span>
                        Analyze large datasets to identify trends and patterns.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Project management:</span>
                        Lead and manage engineering projects from conception to completion.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Cyber security:</span>
                        Protect systems, networks, and data from cyber threats by implementing security measures and
                        protocols.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Artificial Intelligence and Machine Learning:</span>
                        Develop AI algorithms and machine learning models to automate tasks, make predictions, and
                        improve decision-making processes.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Internet of Things (IoT):</span>
                        Design and implement IoT solutions to connect and control devices and systems for various
                        applications such as smart homes, healthcare, and industrial automation.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Cloud Computing</span>
                        Architect, deploy, and manage cloud-based solutions to enable scalable, flexible, and
                        cost-effective IT infrastructure and services.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Augmented Reality (AR) and Virtual Reality (VR)</span>Create immersive
                        experiences and applications using AR and VR technologies for entertainment, education,
                        training, and simulation.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Robotics</span>
                        Design, build, and program robots for industrial automation, healthcare, exploration, and
                        consumer applications.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Renewable Energy</span>
                        Develop sustainable energy solutions such as solar, wind, and hydroelectric power systems to
                        address environmental challenges and energy needs.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Biomedical Engineering</span>
                        Apply engineering principles to healthcare and medicine by designing and developing medical
                        devices, diagnostic tools, and prosthetics.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Environmental Engineering</span>
                        Address environmental issues and sustainability challenges by designing and implementing
                        solutions for pollution control, waste management, and renewable resource utilization.
                    </div>
                </li>
                <li class="flex items-start">
                    <span class="mr-2">➤</span>
                    <div>
                        <span class="font-bold">Aerospace Engineering</span>
                        Design and develop aircraft, spacecraft, and related systems for commercial, military, and
                        space exploration purposes.
                    </div>
                </li>
            </ul>

            <h4 class="text-xl font-bold mb-2">Career Opportunities</h4>
            <ul class="list-disc px-5">
                <li class="text-gray-500  my-2">Students graduating from AST are:
                </li>
                <li class="text-gray-500  my-2"> Proficient Technologists: Skilled in solving complex technological
                    problems.
                </li>
                <li class="text-gray-500  my-2"> Creative Innovators: Ready to drive technological transformation across
                    industries.
                </li>
                <li class="text-gray-500  my-2"> Industry-Ready Professionals: Equipped with skills demanded by the tech
                    and business sectors
                    globally.
                </li>
                <li class="text-gray-500 my-2">At ARNI, we prepare our students not just for jobs — but to
                    become leaders and changemakers in their chosen fields.
                </li>
            </ul>
            <h2 class="text-xl font-bold mb-2">Arni University’s Contribution to Emerging Technologies</h2>
            <p class="text-gray-500  my-2">Arni University is at the forefront of educational innovation by
                constantly updating its programs and infrastructure in response to technological advancements. With
                initiatives like Electric Vehicle labs, AI research centers, and Blockchain study programs, we are
                actively contributing to the global shift towards a technologically empowered future.Our graduates are
                poised to lead in industries such as automotive EV,
                AI innovation, data-driven enterprises, fintech, healthtech, and cybersecurity, shaping a smarter,
                safer, and more connected world.
                <!-- <li class="text-gray-500  my-2">
                 </li>-->
                <!-- <li class="text-gray-500  my-2">
                 </li>-->
            </p>
            <h2 class="text-xl font-bold mb-2">Why Choose ARNI?</h2>
            <ul class="list-disc">
                <li class="text-gray-500 px-5 my-2">Pioneering New-Age Courses
                    Our newly introduced programs in AI-ML, Cloud Computing, Blockchain, and Electric Vehicles are
                    designed to meet the growing demand for specialized skills in future-centric industries.

                    Global Opportunities
                    Partnerships with industries and organizations open up global career pathways for our students.
                </li>
                <li class="text-gray-500  my-2">Industry-Aligned Curriculum
                    Programs are developed with direct input from leading industries to ensure students are job-ready
                    and ahead of the curve.
                </li>
                <li class="text-gray-500  my-2">Cutting-Edge Infrastructure
                    Fully equipped research labs, cloud computing labs, AI-ML centers, and EV workshops offer students
                    hands-on experience in real-world applications.
                </li>
                <li class="text-gray-500  my-2">Focus on Innovation and Research
                    Encouraging students to innovate, research, and publish, AST provides platforms for students to work
                    on live projects, internships, and industry collaborations.
                </li>
                <li class="text-gray-500  my-2">Holistic Development
                    Beyond academics, we nurture leadership, entrepreneurship, and personal growth through workshops,
                    competitions, seminars, and soft skill programs.
                </li>
                <li class="text-gray-500  my-2"> Our graduates are poised to lead in industries such as automotive EV,
                    AI innovation, data-driven enterprises, fintech, healthtech, and cybersecurity, shaping a smarter,
                    safer, and more connected world.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">
                Join us at The ARNI School of Technology, where the scope of your future is as expansive as your
                ambitions.
            </p>
        </div>

    </div>
    <!-- <div id="section3" class="w-full bg-gray-100">
         <div class="max-w-7xl mx-auto p-6">
             <h2 class="text-xl font-bold mb-4">Departments</h2>
             <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                 <div *ngFor="let department of departments" class="bg-white p-4 rounded-lg shadow border h-[100px]">
                     <div class="flex items-center space-x-4">
                         <i class="fa" [ngClass]="department.icon + ' text-blue-600'"></i>
                         <span class="text-lg font-semibold text-gray-800">{{ department.name }}</span>
                     </div>
                 </div>
             </div>
         </div>-->

    <div id="specialization" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">
                Technology Disciplines & Specializations
            </h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div
                    *ngFor="let department of departments"
                    class="bg-white p-5 rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                >
                    <div class="flex items-center mb-4">
                        <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                        <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                    </div>
                    <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                        <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                            <li *ngFor="let branch of department.branches">{{ branch }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">
                B.Tech CSE Specializations
            </h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-center">
                <a href="schools/arni-school-of-technology/btech-cse/artificial-intelligence-and-machine-learning"
                   class="block bg-white shadow-md border border-gray-200 hover:shadow-lg transition-shadow p-6 rounded-2xl hover:bg-blue-100">
                    Artificial Intelligence & Machine Learning
                </a>
                <a href="schools/arni-school-of-technology/btech-cse/data-science"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Data Science
                </a>
                <a href="schools/arni-school-of-technology/btech-cse/cloud-computing"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Cloud Computing
                </a>
                <a href="schools/arni-school-of-technology/btech-cse/cyber-security"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Cyber Security
                </a>
                <a href="schools/arni-school-of-technology/btech-cse/blockchain"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Blockchain Technology
                </a>
                <a href="schools/arni-school-of-technology/btech-cse/iot-applications"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    IOT & Applications
                </a>
            </div>
        </div>

        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">
                B.Tech EE Specializations
            </h2>
            <div class="flex justify-center">
                <a href="schools/arni-school-of-technology/btech-ee/electric-vehicle"
                   class="block bg-white shadow-md border border-gray-200 hover:shadow-lg transition-shadow p-6 rounded-2xl hover:bg-blue-100 w-full md:w-[40%] text-center">
                    Electric Vehicle
                </a>
            </div>
        </div>

        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">
                B.Tech ECE (VLSI) Specializations
            </h2>
            <div class="flex justify-center">
                <a href="schools/arni-school-of-technology/btech-ece/chip-designing"
                   class="block bg-white p-6 shadow-md border border-gray-200 hover:shadow-lg transition-shadow rounded-2xl hover:bg-blue-100 w-full md:w-[40%] text-center">
                    Chip Designing
                </a>
            </div>
        </div>
    </div>

    <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
        <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
            <div>
                <p class="text-3xl font-bold">200+</p>
                <p class="text-lg">Programs</p>
            </div>
            <div>
                <p class="text-3xl font-bold">500+</p>
                <p class="text-lg">Faculties</p>
            </div>
            <div>
                <p class="text-3xl font-bold">11000+</p>
                <p class="text-lg">Students</p>
            </div>
            <div>
                <p class="text-3xl font-bold">120+</p>
                <p class="text-lg">Acre of campus</p>
            </div>

        </div>
    </div>
    <div id="dean-message" class="w-full">
        <div class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img src="assets/img/dean-as-per-schools/dr-gurvinder-singh-arni-school-of-technology.png" alt="Dean"
                     class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Dr. Gurvinder Singh
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto custom-scrollbar">
                <h2 class="text-2xl font-bold mb-2">Dean’s Message</h2>
                <p class="text-gray-700 text-justify">
                    I am very grateful to welcome you all at the ARNI School of Technology at ARNI University – A
                    forward-thinking educational institute with a dynamic environment. At ARNI, we are committed to
                    offering world-class learning to shape the future of upcoming tech leaders and innovators.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    Following the digital landscape, we can say that technology is no longer limited to classrooms and
                    labs; it is now beyond this. The role of technology and innovations is transforming our society,
                    shaping our economics, and redefining how we interact and live.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    As the Dean of ARNI School of Technology, I take great pride in the achievements of our valuable
                    students and faculty. I am very confident that with this dedication, hard work, and support, our
                    School will continue to be a hub of excellence in technology education.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    I invite you to explore the ARNI School of Technology and become a part of our vibrant and growing
                    community.
                </p>
                <p class="text-gray-700 mt-2 text-justify">Warm regards,</p>
                <p class="text-gray-700 mt-2 font-bold text-justify">Dr. Gurvinder Singh</p>
                <p class="text-gray-700 mt-2 text-justify">Dean, ARNI School of Technology</p>
            </div>

        </div>


    </div>
    <div id="whats-happening" class="w-full">
        <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
            <div class="container mx-auto px-6  max-w-6xl">
                <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                        <img [src]="event.image" alt="Event Image" class="w-full h-56 object-cover">
                        <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                            <!--<p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                            <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                            <p class="text-sm text-gray-600 mt-2 text-justify">{{ event.description }}</p>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center mt-10">
                    <a
                        href="/whats-happening/event-calendar"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div id="expert-faculty" class="w-full">
        <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
            <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
            <div class="relative w-full max-w-6xl overflow-hidden">
                <div
                    class="flex transition-transform duration-300 ease-in-out"
                    [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                >
                    <div
                        *ngFor="let faculty of faculties"
                        class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button
                (click)="prev()"
                class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
            >
                <i class="fa fa-chevron-left text-[#012E26]"></i>
            </button>
            <button
                (click)="next()"
                class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
            >
                <i class="fa fa-chevron-right text-[#012E26]"></i>
            </button>

            <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                    (click)="goTo('/about/faculty')">
                View All Faculty
            </button>
        </div>
        <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
            <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
            <div class="w-full">
                <div
                    *ngFor="let faculty of faculties | slice:0:3"
                    class="flex flex-col items-center p-4"
                >
                    <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px] w-[80%]">
                        <div class="h-[140px] flex items-center justify-center">
                            <img
                                [src]="faculty.image"
                                alt="faculty image"
                                class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                            />
                        </div>
                        <div class="h-[140px] flex flex-col items-center justify-center text-center">
                            <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                            <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-center">
                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                        (click)="goTo('/about/faculty')">
                    View All Faculty
                </button>
            </div>
        </div>
    </div>

    <!--<div id="testimonials" class="py-16 bg-white font-montserrat">
        <div class="container mx-auto px-4 text-center">
            <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
            <div class="testimonial-slider relative">
                <div class="overflow-hidden px-2">
                    <div
                        class="flex transition-transform duration-500 ease-in-out"
                        [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                    >
                        <ng-container *ngFor="let group of groupedTestimonials">
                            <div class="w-full flex-shrink-0 flex pb-4">
                                <div
                                    *ngFor="let testimonial of group"
                                    class="w-full md:1/2 lg:w-1/3 px-3"
                                >
                                    <div
                                        class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                        <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                            <div
                                                class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                            >
                                                <div class="w-24 h-24 rounded-full bg-white p-1">
                                                    <img
                                                        [src]="testimonial.image"
                                                        [alt]="testimonial.name"
                                                        class="w-full h-full rounded-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pt-16 pb-8 px-6">
                                            <h3
                                                class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                            >
                                                {{ testimonial.name }}
                                            </h3>
                                            <div class="flex justify-center mb-4">
                                                <i
                                                    class="fa fa-star text-yellow-400"
                                                    *ngFor="let star of [1, 2, 3, 4, 5]"
                                                ></i>
                                            </div>
                                            <p class="text-gray-700 text-center mb-6 ">
                                                {{ testimonial.feedback }}
                                            </p>
                                            <div class="text-center text-sm text-gray-600">
                                                <p class="font-semibold">{{ testimonial.course }}</p>
                                                <p class="font-bold text-[#012E26]">
                                                    Placed In:
                                                    <span class="text-[#00BFA5]">
                          {{ testimonial.company }}
                        </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                &lt;!&ndash; Pagination Dots &ndash;&gt;
                <div class="flex justify-center mt-8 space-x-2">
                    <button
                        *ngFor="let group of groupedTestimonials; let i = index"
                        [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                        class="w-3 h-3 rounded-full transition-all duration-300"
                        (click)="setTestimonialSlide(i)"
                    ></button>
                </div>
            </div>

            <div class="flex justify-center mt-10">
                <a
                    href="/quick-links/student-testimonial"
                    class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                >
                    View More
                </a>
            </div>
        </div>
    </div>-->

    <div id="gallery">
        <div class="container-fluid mb-10">
            <div class="flex flex-col md:flex-row">
                <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                    <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                         class="w-full h-[500px] shadow-lg">
                </div>
                <div class="w-full md:w-2/5 md:pl-4">
                    <iframe class="w-full h-[500px] object-cover shadow-lg"
                            src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
    <div id="recruiters" class="w-full">
        <div class="bg-blue-100 text-center font-sans py-12">
            <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
            <div class="flex items-center justify-center gap-6 py-4">
                <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                        (click)="prevSlide()">&#10094;
                </button>
                <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                    <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                         [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                        <div *ngFor="let recruiter of recruiters"
                             class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                            <img [src]="recruiter.logo" [alt]="recruiter.name"
                                 class="max-w-[80px] sm:max-w-[100px] h-auto">
                        </div>
                    </div>
                </div>
                <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                        (click)="nextSlide()">&#10095;
                </button>
            </div>
            <!--                <button class="mt-4 bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-full">View all</button>-->
        </div>
    </div>
</section>

